import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    height: 32,
    width: 'auto',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return (
    <img
      src="/ibict-horizontal-branca.svg"
      alt="IBICT"
      className={classes.img}
    />
  );
};
